var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWordIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.931,
    height: 46.931,
    "data-name": "microsoft word",
    id: "microsoft-word",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#41a5ee",
    d: "M44.977 2.933H13.688a1.955 1.955 0 0 0-1.955 1.955v8.311l17.6 5.134 17.6-5.133V4.888a1.955 1.955 0 0 0-1.956-1.955Z",
    "data-name": "Path 73"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2b7cd3",
    d: "M46.933 13.199h-35.2v10.266l17.6 5.134 17.6-5.133Z",
    "data-name": "Path 74"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#185abd",
    d: "M46.933 23.466h-35.2v10.266l17.6 5.134 17.6-5.133Z",
    "data-name": "Path 75"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#103f91",
    d: "M46.933 33.732h-35.2v8.311a1.955 1.955 0 0 0 1.955 1.955h31.289a1.955 1.955 0 0 0 1.956-1.955Z",
    "data-name": "Path 76"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.444 10.266H11.733v27.866h12.711a1.961 1.961 0 0 0 1.955-1.955V12.221a1.961 1.961 0 0 0-1.955-1.955Z",
    "data-name": "Path 77",
    opacity: 0.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.977 11.733H11.733v27.866h11.244a1.961 1.961 0 0 0 1.956-1.955V13.688a1.961 1.961 0 0 0-1.956-1.955Z",
    "data-name": "Path 78",
    opacity: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.977 11.733H11.733v24.932h11.244a1.961 1.961 0 0 0 1.956-1.955V13.688a1.961 1.961 0 0 0-1.956-1.955Z",
    "data-name": "Path 79",
    opacity: 0.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.511 11.733h-9.778v24.932h9.778a1.961 1.961 0 0 0 1.955-1.955V13.688a1.961 1.961 0 0 0-1.955-1.955Z",
    "data-name": "Path 80",
    opacity: 0.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#185abd",
    d: "M1.955 11.733h19.556a1.955 1.955 0 0 1 1.955 1.955v19.556a1.955 1.955 0 0 1-1.955 1.955H1.955A1.955 1.955 0 0 1 0 33.244V13.688a1.955 1.955 0 0 1 1.955-1.955Z",
    "data-name": "Path 81"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.526 30.799h-2.639l-3.08-10.12-3.227 10.12H5.94L3.007 16.133h2.64L7.7 26.399l3.08-9.973h2.2l2.933 9.973 2.053-10.266h2.491Z",
    "data-name": "Path 82"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h46.931v46.931H0Z",
    "data-name": "Path 83"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordIcon);
export default __webpack_public_path__ + "static/media/wordIcon.f0cc955c82f8fd3c91b3ecf1fea1c7c3.svg";
export { ForwardRef as ReactComponent };